import React from "react";
import UsageGuideCard from "../usage-guide-card/UsageGuideCard";
import UsageGuideStepProps from "./usage-guide-step-props.interface";
import { ReactComponent as YellowArrowRightIcon } from "../../../../../assets/icons/yellow-arrow-right-icon.svg";

const HeatMapToggle = ({
  handleNextStep,
  handleClose,
}: UsageGuideStepProps) => {
  return (
    <div className="step__heatmap-toggle">
      <UsageGuideCard handleClose={handleClose}>
        <div className="d-flex">
          <div className="mb-5">
            <h1>Generate Heatmap</h1>
            <p>And finally, you can generate a heatmap based on the sun path.</p>
          </div>
          <div className="align-self-end">
            <button
              type="button"
              onClick={handleNextStep}
              className="clickable"
            >
              Next
              <YellowArrowRightIcon/>
            </button>
          </div>
        </div>
      </UsageGuideCard>
    </div>
  );
};

export default HeatMapToggle;
